import { ReactNode } from 'react'
import ReactDOM from 'react-dom'

export interface IPrintPortalProps {
  children: ReactNode
}

export default function PrintPortal({ children }: IPrintPortalProps) {
  const portal = document.getElementById('print-portal')
  
  return (
    portal ?
      ReactDOM.createPortal(children, portal) : null
  )
}